export const AGE_CHECK_COOKIE_NAME = 'age_check';
